export default "__VITE_ASSET__CMhZkwC5__"